// ══════════════════════════════════════════════════════════════════════════
// Tariff Wizard Field Configuration
// ══════════════════════════════════════════════════════════════════════════

export const TARIFF_STEP_LABELS = ['Add Tariff', 'Add Static Tariff Component', 'Go Live'];

export const CURRENCY_OPTIONS = ['GBP', 'EUR', 'USD'];
export const TARIFF_STATUS_OPTIONS = ['Active', 'Inactive', 'Draft'];
export const CHARGING_UNIT_OPTIONS = ['kWh Price', 'Minute Price', 'Flat Fee'];
export const GRACE_PERIOD_OPTIONS = ['15 mins', '30 mins', '45 mins', '60 mins'];
export const BILLING_INCREMENT_OPTIONS = ['Per Second', 'Per Minute', 'Per 15 Minutes'];

export const TARIFF_REQUIRED_FIELDS = [
  { name: 'name', label: 'Tariff Name', type: 'text', placeholder: 'e.g. Standard Rate' },
  { name: 'currency', label: 'Select Currency', type: 'select', options: CURRENCY_OPTIONS },
  { name: 'status', label: 'Tariff Status', type: 'select', options: TARIFF_STATUS_OPTIONS },
];

export const TARIFF_FIELD_GROUPS = [
  {
    key: 'tariff_details',
    title: 'Additional Details',
    icon: 'star',
    fields: [
      { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Describe when and how this tariff should be used...' },
      { name: 'tariff_code', label: 'Tariff Code', type: 'text', placeholder: 'e.g. STD-01' },
      { name: 'effective_from', label: 'Effective From', type: 'date' },
      { name: 'effective_to', label: 'Effective To', type: 'date' },
    ]
  },
];

export const ALL_TARIFF_OPTIONAL_FIELDS = TARIFF_FIELD_GROUPS.flatMap(g => g.fields);

export const PRICE_COMPONENT_REQUIRED_FIELDS = [
  { name: 'charging_unit', label: 'Select Charging Unit', type: 'select', options: CHARGING_UNIT_OPTIONS },
  { name: 'price_per_unit', label: 'Price per/unit', type: 'text', placeholder: 'Price' },
];

// Note: no time_window group here — time-of-day scheduling is applied per
// Station in the EVSE wizard's Add Price step, not on the Tariff itself.
export const PRICE_COMPONENT_FIELD_GROUPS = [
  {
    key: 'component_details',
    title: 'Additional Pricing Rules',
    icon: 'settings',
    fields: [
      { name: 'tax_percent', label: 'Tax (%)', type: 'text', placeholder: 'Tax' },
      { name: 'minimum_charge', label: 'Minimum Charge Amount', type: 'text', placeholder: 'e.g. 1.00' },
      { name: 'billing_increment', label: 'Billing Increment', type: 'select', options: BILLING_INCREMENT_OPTIONS },
    ]
  },
];

export const ALL_PRICE_COMPONENT_OPTIONAL_FIELDS = PRICE_COMPONENT_FIELD_GROUPS.flatMap(g => g.fields);